import { render, staticRenderFns } from "./PlayerScreenshotGallery.vue?vue&type=template&id=1c07e2a6&"
import script from "./PlayerScreenshotGallery.vue?vue&type=script&lang=js&"
export * from "./PlayerScreenshotGallery.vue?vue&type=script&lang=js&"
import style0 from "./PlayerScreenshotGallery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports